import { Typography } from '@mui/material';

function Required() {
  return (
    <Typography variant="inherit" color="error.dark" component="span">
      {' '}
      *
    </Typography>
  );
}

export default Required;
